import { render, staticRenderFns } from "./EventHero.vue?vue&type=template&id=69382622&"
import script from "./EventHero.vue?vue&type=script&lang=js&"
export * from "./EventHero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports